export default __webpack_public_path__ + "static/media/biofit-builder-series-BT.64712b57.png";